export default __webpack_public_path__ + "images/74ee4bfb1d32315dcc48668ab664a3aa-caregiving.svg";